const Constants = {
  DeletionReasonTypes: {
    None: 0,
    UserRequest: 1,
    CompanyRequest: 2
  },

  visitPassActionTypes: {
    submitted: 1,
    approved: 2,
    rejected: 3
  },

  appId: 1
}

export default Constants


// WEBPACK FOOTER //
// ./src/utils/constants.js